import type { CampaignInfluencer } from "@/marketing/models/campaignInfluencer";
import { hasMilestone } from "@/marketing/lib/campaignPipeline";
import {
  STANDARD_PIPELINE_DEFINITION,
  type CampaignPipelineDefinition,
} from "@/marketing/models/campaignPipeline";

type SettlementCandidate = Pick<CampaignInfluencer, "rejected" | "pipelineStage">;

// Paid-track creators earn a settlement row once their stage carries the content_posted milestone.
// A commission carrier campaign never moves its creators past Form Sent, so a settlement the
// backend already opened is reason enough to list them.
export function isSettlementRowEligible(
  influencer: SettlementCandidate,
  hasSettlement: boolean,
  definition: CampaignPipelineDefinition = STANDARD_PIPELINE_DEFINITION,
): boolean {
  if (influencer.rejected) return false;
  return (
    hasSettlement ||
    hasMilestone(definition, influencer.pipelineStage, "content_posted")
  );
}
